/** @format */

import {format, subDays} from 'date-fns';

import {safeDivide} from 'helpers/numberHelpers';
import {FunnelGoalStatFromQuery} from 'pages/Home/DigitalCast/models/api';

export interface CrStats {
  yesterday: number;
  min: number;
  max: number;
  dynamics: number;
}

const computeCrStats = (
  stats: ReadonlyArray<FunnelGoalStatFromQuery>,
  goalAId: number,
  goalBId: number,
): CrStats => {
  const byDate = new Map<string, {numerator: number; denominator: number}>();

  stats.forEach(s => {
    const record = byDate.get(s.date) || {numerator: 0, denominator: 0};
    if (s.goalId === goalAId) record.numerator += s.conversions;
    if (s.goalId === goalBId) record.denominator += s.conversions;
    byDate.set(s.date, record);
  });

  const dates = Array.from(byDate.keys()).sort();
  const crSeries: number[] = dates.map(d => {
    const {numerator, denominator} = byDate.get(d)!;
    return safeDivide(numerator, denominator) * 100;
  });

  // Жёстко берём календарное «вчера» (yyyy-MM-dd)
  const yesterdayKey = format(subDays(new Date(), 1), 'yyyy-MM-dd');
  const yesterdayIndex = dates.indexOf(yesterdayKey);
  const yesterdayRaw = yesterdayIndex >= 0 ? crSeries[yesterdayIndex] : Number.NaN;

  const valid = crSeries.filter(v => Number.isFinite(v));
  if (!valid.length) {
    // eslint-disable-next-line no-console
    console.warn('[CR] computeCrStats: пустой ряд CR', {
      goalAId,
      goalBId,
      statsCount: stats.length,
    });
  }
  const yesterday = Number.isFinite(yesterdayRaw) ? (yesterdayRaw as number) : 0;
  const min = valid.length ? Math.min(...valid) : 0;
  const max = valid.length ? Math.max(...valid) : 0;
  const first = valid.find(v => Number.isFinite(v)) || 0;
  const dynamics = yesterday - first;

  return {yesterday, min, max, dynamics};
};

export default computeCrStats;
